import { Controller } from "@hotwired/stimulus"

// reveal — show/hide item target(s) based on a trigger checkbox's checked
// state, toggling a configurable class (default "hidden").
//
// Markup (see app/views/products/_form.html.erb):
//   <div data-controller="reveal" data-reveal-hidden-class="hidden">
//     <label>
//       <input type="checkbox"
//              data-reveal-target="trigger"
//              data-action="change->reveal#toggle">
//     </label>
//     <div data-reveal-target="item">…revealed content…</div>
//   </div>
//
// connect() syncs the initial state so the item matches the checkbox on load.
export default class extends Controller {
  static targets = ["trigger", "item"]

  connect() {
    this._sync()
  }

  toggle() {
    this._sync()
  }

  _sync() {
    if (!this.hasTriggerTarget) return
    const hiddenClass = this.element.dataset.revealHiddenClass || "hidden"
    const show = this.triggerTarget.checked
    this.itemTargets.forEach((item) => {
      item.classList.toggle(hiddenClass, !show)
    })
  }
}
